module.exports = __webpack_public_path__ + "img/744.221d8a33.jpg";